import React from 'react';

const PhotoGallery = () => (
    <div>
        <h2>PhotoGallery Page</h2>
    </div>
);

export default PhotoGallery;
